import { VEHICLES_API } from '../../../constants/api';
import { getData } from '../../../helper/services/axios';

export function fetchVehicles(params = '') {
	return getData(VEHICLES_API, params);
}
